$.fn.vertAlign = function(){
	return this.each(function(){
		var height = $(this).outerHeight();
		var pullUp = height / 2;
		$(this).css({
			top: '50%',
			marginTop: '-'+pullUp+'px'
		});
	});
};